import { useMemo } from 'react';

import { useSuspenseQuery } from '@/hooks/use-suspense-query';

import { organizationsApi } from './organisation-api';

/**
 * Organizations query hooks using React Query
 */

export function useUserOrganisations(userId: string) {
  const { data, ...rest } = useSuspenseQuery(
    organizationsApi.getUserOrganizations(userId),
  );

  const transformedData = useMemo(() => {
    return (
      data?.map((d) => ({
        ...d.organisation,
      })) ?? []
    );
  }, [data]);

  return {
    data: transformedData,
    ...rest,
  };
}

export function useOrganisation(tenantId: string) {
  return useSuspenseQuery(organizationsApi.getOrganisation(tenantId));
}

export function useAllOrganisations() {
  const { data, ...rest } = useSuspenseQuery(
    organizationsApi.getAllOrganisations(),
  );

  const transformedData = useMemo(() => {
    return (
      data?.map(({ organisation_member, ...org }) => ({
        ...org,
        members: organisation_member[0].count,
      })) ?? []
    );
  }, [data]);

  return {
    data: transformedData,
    ...rest,
  };
}
